// START IMPORTS
import { Box, useMediaQuery } from '@ltvco/refresh-lib/theme';
import { DateUtil } from '@ltvco/refresh-lib/utils';

import { metadataRowSegment } from 'components/DeepSearch/components/ReportLibrary/utils/index';

import type { ReportListMetadataRowProps } from 'components/DeepSearch/components/ReportLibrary/Lists/components/ReportListItem/types';
// END IMPORTS

const dateParser = new DateUtil();

const formatDate = (value: string): string => {
  const parsed = dateParser.parseDateFromString(value, 'M/d/yyyy');
  if (parsed) {
    return parsed;
  }

  const date = new Date(value);
  if (!isNaN(date.getTime())) {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

  return value;
};

const separator = (
  <Box component="span" sx={{ userSelect: 'none' }}>
    {' | '}
  </Box>
);

/** Updated / Created (or Monitored) / Viewed row. Accepts any parseable date string. */
export function ReportListMetadataRow({
  updated,
  created,
  viewed,
  middleLabel = 'Created',
}: ReportListMetadataRowProps) {
  const isMobile = useMediaQuery('(max-width: 600px)');
  const middleWord = middleLabel === 'Monitored' ? 'Monitored' : 'Created';

  const baseSx = {
    fontSize: '0.8125rem',
    lineHeight: 1.5,
    color: 'text.secondary',
    letterSpacing: 0.01,
  };

  if (isMobile) {
    return (
      <Box
        component="div"
        sx={{ ...baseSx, display: 'flex', flexDirection: 'column', gap: 0.25 }}
      >
        <Box>{metadataRowSegment('Updated', formatDate(updated))}</Box>
        <Box>{metadataRowSegment(middleWord, formatDate(created))}</Box>
        <Box>{metadataRowSegment('Viewed', formatDate(viewed))}</Box>
      </Box>
    );
  }

  return (
    <Box component="div" sx={baseSx}>
      {metadataRowSegment('Updated', formatDate(updated))}
      {separator}
      {metadataRowSegment(middleWord, formatDate(created))}
      {separator}
      {metadataRowSegment('Viewed', formatDate(viewed))}
    </Box>
  );
}
